import cloneDeep from 'lodash/cloneDeep';

import { TPrice, TProduct } from '~/src/features/full-buy/store/transformShopItem';

const getProductsCloneAndCurrentClone = (products: TProduct[], id: number) => {
    const cloneProducts = cloneDeep(products);
    const currProduct = cloneProducts?.find(el => el.id === id);

    return {
        cloneProducts,
        currProduct,
    };
};

/**
 * Возвращает массив продуктов, изменяет количество для указанного id
 * @param products - исходный массив продуктов
 * @param id -  изменяемый продукт
 * @param quantity - устанавливаемое количество
 */
export const changeQuantity = (products: TProduct[], id: number, quantity: number) => {
    if (!products.length) {
        return products;
    }

    const { cloneProducts, currProduct } = getProductsCloneAndCurrentClone(products, id);

    if (!currProduct) {
        return products;
    }

    currProduct.quantity = quantity > 0 ? quantity : 0;

    return cloneProducts;
};

/**
 * Возвращает массив продуктов, с увеличенным на единицу количеством для id
 */
export const increaseQuantity = (products: TProduct[], id: number) => {
    if (!products.length) {
        return products;
    }

    const { cloneProducts, currProduct } = getProductsCloneAndCurrentClone(products, id);

    if (!currProduct) {
        return products;
    }

    const incQuantity = currProduct.quantity + 1;
    currProduct.quantity = incQuantity;
    return cloneProducts;
};

/**
 * Возвращает массив продуктов, с уменьшенным на единицу количеством для id
 */
export const decreaseQuantity = (products: TProduct[], id: number) => {
    if (!products.length) {
        return products;
    }

    const { cloneProducts, currProduct } = getProductsCloneAndCurrentClone(products, id);

    if (!currProduct) {
        return products;
    }

    const decQuantity = currProduct.quantity - 1;

    currProduct.quantity = decQuantity < 0 ? 0 : decQuantity;

    return cloneProducts;
};

const getPriceByDuration = (prices: TPrice[], duration: number) => prices.find(el => el.duration === duration);

/**
 * Возвращает массив продуктов, изменяет выбранную цену для id
 * @param products - исходный массив продуктов
 * @param id -  изменяемый продукт
 * @param duration - параметр объекта цены
 */
 export const changeSelectedPrice = (products: TProduct[], id: number, duration: number) => {
    if (!products.length) {
        return products;
    }

    const { cloneProducts, currProduct } = getProductsCloneAndCurrentClone(products, id);

    if (!currProduct) {
        return products;
    }

    const newSelectedPrice = getPriceByDuration(currProduct.prices, duration);

    if (!newSelectedPrice) {
        return products;
    }

    currProduct.selectedPrice = newSelectedPrice;

    return cloneProducts;
};
